import {
    ComposedChart,
    Area,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    Legend,
} from "recharts";
import commonArray from "./common/commonArray";

const Graph = (props: any) => {
    const dayOrder = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    const monthOrder = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const getXAxisDataKey = () => {
        if (props.Match === "DAILY") return "hour";
        if (props.Match === "WEEKLY") return "day";
        if (props.Match === "MONTHLY") return "date";
        if (props.Match === "YEARLY") return "month";
        return props.xAxis || "hour";
    };

    const getYAxisDataKey = () => {
        if (props.run === "product") return "total_products";
        if (props.run === "sales") return "total_orders";
        if (props.run === "users") return "total_users";
        return props.yAxis || "total_products";
    };

    const getYAxisLabel = () => {
        if (props.run === "product") return "Total Products";
        if (props.run === "sales") return "Total Orders";
        if (props.run === "users") return "Total Users";
        return "Total Products";
    };

    const xAxisDataKey = getXAxisDataKey();
    const yAxisDataKey = getYAxisDataKey();
    const yAxisLabel = getYAxisLabel();

    const sortedData = [...(props.data || [])].sort((a, b) => {
        if (props.Match === "WEEKLY") {
            return dayOrder.indexOf(a.day) - dayOrder.indexOf(b.day);
        }
        if (props.Match === "YEARLY") {
            return monthOrder.indexOf(a.month) - monthOrder.indexOf(b.month);
        }
        if (props.Match === "DAILY") {
            return parseInt(a.hour) - parseInt(b.hour);
        }
        if (props.Match === "MONTHLY") {
            return parseInt(a.date) - parseInt(b.date);
        }
        return 0;
    });

    const CustomTooltip = ({ active, payload, label }: any) => {
        if (active && payload && payload.length) {
            return (
                <div
                    style={{
                        background: "#fff",
                        border: "1px solid #ddd",
                        padding: "10px 12px",
                        borderRadius: "6px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    }}
                >
                    <p style={{ margin: 0, color: "#555", fontWeight: 500 }}>{label}</p>
                    <p style={{ margin: "6px 0 0", color: "#9900CD", fontWeight: 600 }}>
                        {yAxisLabel}: {payload[0]?.value ?? 0}
                    </p>
                </div>
            );
        }
        return null;
    };

    return (
        <div className="col-xl-6 px-0 px-md-2">
            <div className="common-card">
                <div className="common-card-title d-flex justify-content-between align-items-center flex-column flex-md-row">
                    <h5 className="text-nowrap mb-2 mb-md-0">{props.heading}</h5>
                    <div className="btn-group">
                        {commonArray.buttonArray.map((res, index: number) => (
                            <button
                                className={`btn btn-white ${props.Match === res.toUpperCase() ? "active-btn" : ""}`}
                                type="button"
                                onClick={() => props.dashboadGraph(props.run, res.toUpperCase())}
                                disabled={props.loading}
                                key={index}
                            >
                                {res}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="common-card-content">
                    <ResponsiveContainer width="100%" height={300}>
                        <ComposedChart data={sortedData}>
                            <XAxis
                                dataKey={xAxisDataKey}
                                stroke="#2f4050"
                                tickFormatter={(value) => {
                                    if (props.Match === "DAILY") {
                                        return String(value).padStart(2, "0");
                                    }
                                    return value;
                                }}
                            />
                            <YAxis allowDecimals={false} />
                            <Tooltip
                                content={<CustomTooltip />}
                                cursor={{ stroke: "#9900CD", strokeDasharray: "3 3" }}
                            />
                            <Legend
                                formatter={() => (
                                    <span style={{ color: "#9900CD" }}>{yAxisLabel}</span>
                                )}
                            />

                            <Area
                                type="monotone"
                                dataKey={yAxisDataKey}
                                name={yAxisLabel}
                                stroke="#243b53"
                                strokeWidth={1.2}
                                fill="#9900CD"
                                fillOpacity={0.15}
                                dot={false}
                                activeDot={{ r: 4 }}
                            />
                        </ComposedChart>
                    </ResponsiveContainer>
                </div>
            </div>
        </div>
    );
};

export default Graph;